import { Component } from '@angular/core';
import { ModelList } from 'projects/core/src/include/modellist';
import { DossierOverview } from '../../../dossier';
import { UntypedFormBuilder } from '@angular/forms';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { DetailOverviewComponent } from './detail/detail.component';
import { DossierOverviewsService } from '../../../services/dossieroverviews.service';
import { Filter, FilterMode, OrderingMode } from 'projects/core/src/include/structures';
import { Type } from 'projects/c1-backend/src/app/db/type';

@Component({
  selector: 'app-dossieroverviews',
  templateUrl: './overviews.component.html',
  styleUrl: './overviews.component.css'
})
export class OverviewsComponent extends ModelList<DossierOverview> {

  override modulename: string="dossier";

  filter_search:Filter=new Filter();
  filter_status:Filter=new Filter();
  filter_id_type:Filter=new Filter();
  type_dossier:Type[]=[];


  

  constructor(
    private fb1: UntypedFormBuilder,
    private dossieroverviewsService: DossierOverviewsService,
    private typesService:TypesService
  ) { 
    super(dossieroverviewsService,fb1);
    this.detailViewModal=DetailOverviewComponent;
  }


  override ngOnInit(): void {
    super.ngOnInit.apply(this);

    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("do.name");
    this.filter_search.value="";
    this.filter.push(this.filter_search);

    this.filter_id_type.mode=FilterMode.like;
    this.filter_id_type.fields=[];
    this.filter_id_type.fields.push("do.id_type");
    this.filter_id_type.value="";
    this.filter.push(this.filter_id_type);

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("do.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);

    this.ordering.field="id_type,ordering";
    this.ordering.mode=OrderingMode.ascendent;
  
    this.typesService.getTypes("dossier").subscribe((items)=>{
      this.type_dossier=items;
      this.getItems();

    });

  }
}
